import { API_TYPE } from '@umu/umu-fetch';
const N_API = '/napi';

export const NodeCourseAPI = {
    N_GET_COURSE_INFO: {
        url: `${N_API}/course/get-course-info`,
        type: API_TYPE.GET,
    },
};
